/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'jwt-match-readonly';
const prefix = `${moduleName}.${componentName}`;

export const jwtLabel = `${prefix}.jwtLabel`;

export const ENGLISH = {
    [jwtLabel]: 'JSON Web Tokens (JWT)',
};
